export default __webpack_public_path__ + "static/media/Al 1de Burdan Yak.79a501db.mp3";